import { Result } from "domain/entities/result";
import { DrugTripletInteractionRepository } from "domain/repositories";

export default class DeleteUseCase {
    private drugTripletInteractionRepository: DrugTripletInteractionRepository;
    
    public constructor(drugTripletInteractionRepository: DrugTripletInteractionRepository) {
        this.drugTripletInteractionRepository = drugTripletInteractionRepository
    }

    public async deleteDrugTripletInteraction(id: number, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugTripletInteractionRepository.deleteDrugTripletInteraction(id, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}